// Copyright © 2021 Move Closer
export const AuthRepositoryType = Symbol.for('AuthRepository');
export const UserRepositoryType = Symbol.for('UserRepository');
export const CardsRepositoryType = Symbol.for('CardsRepository');
